export enum HorizontalNavPositions {
    ABOVE_THE_HEADER = "above_the_header",
    INSIDE_THE_HEADER = "inside_the_header",
    BELOW_THE_HEADER = "below_the_header"
}

export default HorizontalNavPositions;